module.exports = __webpack_public_path__ + "img/6-8.4a8fb78a.png";